// Tandem Tool System — desktop-only, single execution path (no appType branching).
// File tools use window.tandemAPI (revolt-desktop TandemManager), not workspace IPC.

import { ToolSystem } from "../../../base/ToolSystem.js";
import {
  CreateFolderTool,
  DeleteFileTool,
  DuplicateFileTool,
  EditFileTool,
  ListDirectoryTool,
  MoveFileTool,
  ReadFileTool,
  WriteFileTool,
} from "../implementations/file/index.js";
import { TandemAgentEntriesTool } from "../implementations/agents/TandemAgentEntriesTool.js";

export class TandemToolSystem extends ToolSystem {
  constructor() {
    super();
    /** Section TandemManager when wired via connectInstanceSystems */
    this.tandemManager = null;

    this.registerTool(ReadFileTool);
    this.registerTool(WriteFileTool);
    this.registerTool(DeleteFileTool);
    this.registerTool(ListDirectoryTool);
    this.registerTool(CreateFolderTool);
    this.registerTool(MoveFileTool);
    this.registerTool(DuplicateFileTool);
    this.registerTool(EditFileTool);
    this.registerTool(TandemAgentEntriesTool);
  }

  /**
   * @param {*} manager — section `TandemManager` (connectInstanceSystems uses this name for compatibility)
   */
  setWorkspaceManager(manager) {
    this.tandemManager = manager;
  }
}
